<template>
  <div v-if="isPermissionOk"
       class="wrapper"
       :class="{ 'background-active': isActive }">

    <div class="element-wrapper"
         @click="clickEvent">

      <p class="title"
         :class="{ 'active': isActive }">
        {{ title }}
      </p>

      <div v-if="isVisibleChildren"
           class="arrow-wrapper">

        <img class="arrow"
             :class="{ 'active': isFoldState }"
             :src="arrowIcon"
             title="arrow-icon"/>

      </div>

    </div>

    <div v-show="isFoldState"
         class="children-wrapper">

      <div class="children"
           v-for="(child, index) in children"
           :key="index">

        <nested-element :user-permission="userPermission"
                        :state="state"
                        :permission="child.permission"
                        :path="child.path"
                        :title="child.name"
                        :children="child.children"
                        :fold="child.fold"
                        :default="child.default"
                        :page-name="child.pageName"
                        :change-state="changeState"
                        :element-click-event="elementClickEvent"/>

      </div>

    </div>

  </div>
</template>

<script>
import ArrowAsset from '../assets/arrow.svg';

export default {
  name: 'NestedElement',
  props: {
    elementClickEvent: {
      type: Function,
      isRequired: true,
    },
    userPermission: {
      type: String,
      isRequired: true,
    },
    state: {
      type: String,
      isRequired: true,
    },
    title: {
      type: String,
      isRequired: true,
    },
    children: {
      isRequired: true,
    },
    permission: {
      type: Array,
      isRequired: true,
    },
    path: {
      type: String,
      isRequired: true,
    },
    fold: {
      type: Boolean,
      isRequired: true,
    },
    pageName: {
      type: String,
      isRequired: true,
    },
    changeState: {
      type: Function,
      isRequired: true,
    },
    default: {
      type: Boolean,
      isRequired: true,
    },
  },
  computed: {
    isVisibleChildren() {
      return this.children !== undefined;
    },

    isFoldState() {
      return this.foldState;
    },

    isActive() {
      return this.state === this.pageName;
    },

    isPermissionOk() {
      if (this.permission === undefined || this.permission === null) return true;

      return this.permission.includes(this.userPermission);
    },
  },
  methods: {
    async clickEvent() {
      await this.elementClickEvent();

      if (this.isVisibleChildren) {
        this.folding();
        return;
      }
      this.moveLocation();
    },

    folding() {
      this.foldState = !this.foldState;
    },

    moveLocation() {
      this.changeState(this.pageName);
    },
  },
  data() {
    return {
      arrowIcon: ArrowAsset,
      foldState: this.fold,
      selectState: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {

  .element-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 40px;


    .title {
      margin: 0;
      padding: 0;

      margin-left: 20px;

      font-size: 0.9rem;
      text-align: left;
      color: rgba(255, 255, 255, 0.6);
    }

    .title.active {
      color: rgb(255, 255, 255);
    }

    .arrow-wrapper {
      margin-right: 20px;

      .arrow {
        width: 12px;
        height: 12px;
        transform: rotate(-90deg);
        transition: transform 0.2s ease-in-out 0s;
      }

      .active {
        transform: rotate(-270deg);
      }
    }
  }

  .children-wrapper {
    padding-left: 20px;

    .children {

    }
  }
}

.background-active {
  background-color: rgba(0, 0, 0, 0.2);
}

.wrapper:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/modules/sidebar/nested-sidebar/NestedElement.vue